import React, { useEffect, useState } from "react";
import { Button, Grid, Menu, Typography, useTheme } from "@mui/material";
import { IoCalendar, IoChevronDown } from "react-icons/io5";
import { DatePicker } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { bool, string, object, func } from "prop-types";
import { getMinDate, getMaxDate } from "@/utils";

/**
 *
 * @param props
 */
export const YearPicker = (props: any) => {
  const { getSelectedYearDate } = props;
  // const {TextDomainContext} = useTextDomainContext();
  // const {gettext} = useContext(TextDomainContext);
  const theme = useTheme();
  const localStorageKey = "YearPicker";
  let defaultSelectedYearDate = new Date();
  defaultSelectedYearDate.setDate(1);
  defaultSelectedYearDate.setMonth(defaultSelectedYearDate.getMonth() - 1);

  const cacheValues = JSON.parse(localStorage.getItem(localStorageKey));

  if (cacheValues?.selectedYearDate) {
    defaultSelectedYearDate = new Date(cacheValues.selectedYearDate);
  } else if (typeof props.selectedDate !== "undefined") {
    defaultSelectedYearDate = new Date(props.selectedYearDate);
  }

  const defaultOptions = {
    selectedYearDate: defaultSelectedYearDate,
  };

  // const [startDateValue, setStartDateValue] = useState(new Date());
  // const [endDateValue, setEndDateValue] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedYearDate, setSelectedYearDate] = useState(
    defaultOptions.selectedYearDate,
  );

  const handleSegmentClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (typeof getSelectedYearDate === "function") {
      getSelectedYearDate(selectedYearDate);
    }
    // Remove handleSegmentClose() call to avoid cascading renders
  }, [getSelectedYearDate, selectedYearDate]);

  // const dateValueChange = event => {
  //   const [start, end] = event;
  //   setStartDateValue(start);
  //   setEndDateValue(end);
  //   if (start && end && props.onValueChange) {
  //     props.onValueChange(event);
  //   }
  // };

  // const selectedOptions = {
  //   ...defaultOptions, ...props
  // };

  // useEffect(() => {
  //   if (selectedOptions.defaultStartDate) {
  //     setStartDateValue(selectedOptions.defaultStartDate);
  //   }
  // }, [selectedOptions.defaultStartDate]);

  // useEffect(() => {
  //   if (selectedOptions.defaultEndDate) {
  //     setEndDateValue(selectedOptions.defaultEndDate);
  //   }
  // }, [selectedOptions.defaultEndDate]);

  const handleSegmentClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateChange = (event: any) => {
    setSelectedYearDate(event);
    const item = {
      selectedYearDate: event,
    };
    localStorage.setItem(localStorageKey, JSON.stringify(item));
    handleSegmentClose();
    // console.log(event);
    // const [start, end] = event;
    // setStartDate(start);
    // setEndDate(end);
    // if (start && end) {
    //   const item = {
    //     startDate: start,
    //     endDate: end,
    //     segmentIndex,
    //     selectedSegment
    //   };
    //
    //   localStorage.setItem(localStorageKey, JSON.stringify(item));
    //
    //   handleSegmentClose();
    // }
  };

  // const formattedDate = () => {
  //   let dateStart = new Date();
  //   let dateEnd = new Date();
  //   if (startDate) {
  //     dateStart = startDate;
  //   }
  //
  //   if (endDate) {
  //     dateEnd = endDate;
  //   }
  //
  //   const dayStart = dateStart.getDate();
  //   const monthStart = dateStart.toLocaleString("default", {
  // duplicate declaration removed
  //   });
  //   const yearStart = dateStart.getFullYear();
  //
  //   const dayEnd = dateEnd.getDate();
  //   const monthEnd = dateEnd.toLocaleString("default", {
  //     month: "short"
  //   });
  //   const yearEnd = dateEnd.getFullYear();
  //
  //   if (selectedSegment === "year") {
  //     return `${yearStart} - ${yearEnd}`;
  //   } else if (selectedSegment === "month") {
  //     return `${monthStart} ${yearStart} - ${monthEnd} ${yearEnd}`;
  //   } else {
  //     return `${dayStart} ${monthStart} ${yearStart} - ${dayEnd} ${monthEnd} ${yearEnd}`;
  //   }
  // };

  return (
    <>
      {props.view === "table" ? (
        <Button
          endIcon={<IoChevronDown size={12} />}
          size="large"
          onClick={handleSegmentClick}
          sx={{
            width: "160px",
            "&:hover": {
              backgroundColor: "#fff",
              border: "1px solid #E4E4E7",
            },
          }}
        >
          <Typography
            sx={{ fontSize: "14px", fontWeight: "500", color: "secondary.800" }}
          >
            Calender
          </Typography>
        </Button>
      ) : (
        <Button
          variant="outlined"
          size="large"
          // color="secondary"
          style={{
            color: theme.palette.grey[600],
            // height: "32px",
          }}
          endIcon={<IoCalendar />}
          onClick={handleSegmentClick}
        >
          <Typography sx={{ fontSize: "14px", fontWeight: "fontWeightMedium" }}>
            {selectedYearDate.getFullYear()}
            {/*{formattedDate()}*/}
          </Typography>
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleSegmentClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          ".MuiMenu-list": {
            padding: 0,
            height: "100%",
          },
          "& .MuiMenu-paper": {
            width: "280px",
            borderRadius: "8px",
            boxShadow:
              "0px 10px 15px -3px #0000001A ,0px 4px 6px -2px #0000000F",
            overflow: "hidden",
          },
          "& .MuiMenuItem-root": {
            fontWeight: 400,
            fontSize: "14px",
          },
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: "secondary.900",
            fontWeight: 600,
            fontSize: "14px",
            color: "white",
          },
          "& .react-datepicker__year-wrapper": {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            maxWidth: "100%",
          },
          "& .react-datepicker__year .react-datepicker__year-text": {
            display: "flex",
            color: "#27272a",
            width: "calc(33.333% - 8px)",
            height: "50px",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            margin: "4px",
            borderRadius: "4px",
          },
          "& .react-datepicker__year-text:hover": {
            backgroundColor: "secondary.100",
          },
          "& .react-datepicker__year-text--selected": {
            backgroundColor: "secondary.900 !important",
            color: "white !important",
            fontWeight: 600,
          },
          "& .react-datepicker__year-text--disabled": {
            color: "#d4d4d8",
            cursor: "not-allowed",
          },
          "& .react-datepicker__header": {
            backgroundColor: "#fff",
            color: "#27272a",
            borderBottom: "none",
            fontWeight: 600,
            fontSize: "16px",
            paddingTop: "10px",
          },
        }}
      >
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <DatePicker
              className="my-datepicker"
              selected={selectedYearDate}
              onChange={handleDateChange}
              dateFormat="yyyy"
              showMonthDropdown={false}
              showYearPicker
              dropdownMode="select"
              inline
              minDate={props.minDate || getMinDate(props.pastYears)}
              maxDate={
                props.maxDate ||
                getMaxDate(props.futureYears ?? props.futureDates)
              }
            ></DatePicker>
          </Grid>
        </Grid>
      </Menu>

      {/*<DatePicker*/}
      {/*  customInput={<ButtonInput {...props} />}*/}
      {/*  selectsRange*/}
      {/*  onChange={dateValueChange}*/}
      {/*  {...selectedOptions}*/}
      {/*>*/}
      {/*  <Typography fontSize="14px" color={"secondary.900"}>{selectedOptions.note}</Typography>*/}
      {/*</DatePicker>*/}
    </>
  );
};

YearPicker.propTypes = {
  futureDates: bool,
  view: string,
  selectedDate: object,
  selectedYearDate: object,
  getSelectedYearDate: func,
};
